import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'
import type { SvgIconComponent } from '@mui/icons-material'

// Per-link-type chip styling. Adding a new link_type is one entry plus a
// matching label in REFERENCE_LINK_TYPE_LABELS. Unknown types fall back
// to FALLBACK_LINK_STYLE so the chip still renders.
export type LinkChipStyle = {
  icon: SvgIconComponent
  fg: string
  bg?: string
}

// The known reference-link types. The single source for the literal union so
// that anything keying into LINK_STYLES (chips, the drawer's iconType glyph)
// stays constrained to these values - no arbitrary MUI icon names.
export type ReferenceLinkType =
  | 'fix_guide'
  | 'video'
  | 'overview'
  | 'contact'

export const LINK_STYLES: Record<ReferenceLinkType, LinkChipStyle> = {
  fix_guide: {
    icon: OpenInNewIcon,
    fg: '#007F98',
  },
  video: {
    icon: PlayCircleOutlineIcon,
    fg: '#EC1C5A',
  },
  overview: {
    icon: InfoOutlinedIcon,
    fg: '#007A87',
  },
  contact: {
    icon: SupportAgentIcon,
    fg: '#6B7280',
  },
}

export const FALLBACK_LINK_STYLE: LinkChipStyle = {
  icon: OpenInNewIcon,
  fg: '#6B7280',
}

export const REFERENCE_LINK_TYPE_LABELS: Record<string, string> = {
  fix_guide: 'Fix Guide',
  video: 'Video',
  overview: 'Overview',
  contact: 'Contact',
}

export const referenceLinkTypeLabel = (linkType: string): string =>
  REFERENCE_LINK_TYPE_LABELS[linkType] ?? linkType

export const ALLOWED_LINK_TYPES = Object.keys(LINK_STYLES)
